module.exports = __webpack_public_path__ + "img/cweb.6635a23a.svg";